// 深色
import { createDarkTheme } from './components/create'
import { headerDarkTheme } from './components/header'
import { homeDarkTheme } from './components/home'
import { settingsDarkTheme } from './components/settings'
import { createCollectionDarkTheme } from './components/createCollection'
import { detailDarkTheme } from './components/detail'
import { marketDarkTheme } from './components/market'
import { searchResultDarkTheme } from './components/searchResult'
import { mysteryDarkTheme } from './components/mystery'
import { mysteryDetailDarkTheme } from './components/mysteryDetail'
import { myCollectionsDarkTheme } from './components/myCollections'
import { collectionsDarkTheme } from './components/collections'
import { myNftsDarkTheme } from './components/myNfts'
import { sellDarkTheme } from './components/sell'
import { whitePaperDarkTheme } from './components/whitePaper'
import { globalDarkTheme } from './components/global'

const darkTheme = {
  '--main-bgc-1': '#141417',
  '--main-font-c': '#fff',
  '--global-skeleton-loading-bgc-c':
    'linear-gradient( 90deg, rgba(71, 86, 93, 1) 25%, rgba(63, 70, 80, 1) 37%, rgba(71, 86, 93, 1) 63%)',
  '--modal-bgc-1': '#23262f',
  '--modal-font-c-1': '#fff',
  '--modal-border-c-1': '#3b3e49',

  '--trade-modal-bgc-1': '#ffab65',
  '--trade-modal-font-c-1': '#fff',
  '--trade-modal-font-c-2': '#41cc8b',

  '--global-payments-bgc-1': '#65D5FF',
  '--global-payments-font-c-1': '#fff',
  '--global-payments-font-c-2': '#fff',
  '--global-payments-border-c-1': '#65d5ff',

  '--cust-notification-bgc-1': '#23262f',
  '--cust-notification-font-c-1': '#fff',

  '--language-bgc-1': '#23262f',
  '--language-font-c-1': '#fff',
  '--language-font-c-2': '#9fa7b3',
  '--language-font-c-3': '#fff',
  '--language-shadow-c-1': 'rgba(0, 0, 0, 0.58)',
  '--language-border-c-1': 'rgba(255, 255, 255, 0.19)',

  '--select-bgc-1': '#23262f',
  '--select-bgc-2': '#343b4a',
  '--select-bgc-3': '#23262f',
  '--select-bgc-4': 'rgba(52, 59, 74, 0.5)',
  '--select-font-c-1': '#fff',
  '--select-border-c-1': '#3b3e49',
  '--input-bgc-1': '#373b46',
  '--input-font-c-1': '#9fa7b3',
  '--search-bgc-1': '#23262f',
  '--search-font-c-1': '#fff',
  '--search-font-c-2': '#9fa7b3',

  '--inftFooter-bgc-1': '#23262f',
  '--inftFooter-font-c-1': '#fff',
  '--inftFooter-font-c-2': '#9faeb3',
  '--theme-font-c-1': '#b1b1b1',

  '--card-message-bgc-1': '#23262f',
  '--card-message-bgc-2': 'rgba(27, 22, 50, 0.39)',
  '--card-message-bgc-3': '#fff',
  '--card-message-font-c-1': '#fff',
  '--card-message-font-c-2': '#9fa7b3',
  '--card-message-font-c-3': '#9faeb3',
  '--card-message-font-c-4': '#fb3225',
  '--card-message-font-c-5': '#fff',
  '--card-message-border-c-1': '#3b3e49',
  '--card-message-shadow-c-1': 'rgb(4, 17, 29, 0.25)',
  '--card-message-shadow-c-2': 'rgba(5, 5, 5, 0.33)',

  '--filter-bgc-1': '#141417',
  '--filter-bgc-2': '#23262f',
  '--filter-bgc-3': '#23262f',
  '--filter-bgc-4': '#141417',
  '--filter-bgc-5': '#23262f',
  '--filter-font-c-1': '#fff',
  '--filter-font-c-2': '#65d5ff',
  '--filter-font-c-3': '#f75b3d',
  '--filter-border-c-1': '#343b4a',
  '--filter-border-c-2': '#ffff',
  '--filter-border-c-3': '#65d5ff',

  '--collection-bgc-1': '#23262f',
  '--collection-bgc-2': '#46545C',
  '--collection-bgc-3': '#fff',
  '--collection-bgc-4': 'linear-gradient(90deg, #65d5ff, #5c8dff)',
  '--collection-bgc-5': '#454953',
  '--collection-bgc-6': '#191c22',
  '--collection-font-c-1': '#fff',
  '--collection-font-c-2': '#65d5ff',
  '--collection-font-c-3': '#fff',
  '--collection-font-c-4': '#9fa7b3',
  '--collection-border-c-1': '#3b3e49',

  '--button-bgc-1': 'linear-gradient(341deg, #5c8dff 9%, #65d5ff 83%)',
  '--button-bgc-2': 'linear-gradient(341deg, #0989e5 9%, #37dffd 83%)',
  '--button-font-c-1': '#fff',
  '--button-font-c-2': '#fff',
  '--button-border-c-1': '#65d5ff',
  '--describe-bgc-1': '#141417',
  '--banner-portrait-skeletion-border-c-1': '#141417',

  '--inft-Share-bgc-1': '#23262f',
  '--inft-Share-bgc-2': '#343b4a',
  '--inft-Share-font-c-1': '#fff',
  '--inft-Share-font-c-2': '#65d5ff',
  '--inft-Share-font-c-3': '#9fa7b3',
  '--inft-Share-font-c-4': '#fff',
  '--inft-Share-border-c-1': '#23262f',
  '--inft-Share-shadow-c-1': '#171d36',

  ...createDarkTheme,
  ...headerDarkTheme,
  ...homeDarkTheme,
  ...settingsDarkTheme,
  ...createCollectionDarkTheme,
  ...detailDarkTheme,
  ...marketDarkTheme,
  ...searchResultDarkTheme,
  ...mysteryDarkTheme,
  ...mysteryDetailDarkTheme,
  ...myCollectionsDarkTheme,
  ...collectionsDarkTheme,
  ...myNftsDarkTheme,
  ...sellDarkTheme,
  ...whitePaperDarkTheme,
  ...globalDarkTheme,
}

export default darkTheme
